import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-search-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})
export class SearchItemComponent implements OnInit {

  @Output() removeRule = new EventEmitter<any>();

  @Input() rules: {
    field: string,
    opr: string,
    value: any,
    type: string
  };

  @Input() fields: any[];
  loaded = false;

  selected_type = "boolean";
  multi_select_values = [];
  options: any[];





  constructor(private globalService: GlobalService) {
   
  }



  ngOnInit() {
    this.GetType();
    this.loaded = true;
  }

  async GetType() {
    console.log(this.rules.field);
    let index = this.fields.findIndex(item => item.name === this.rules.field);
    this.selected_type = this.fields[index].type;
    this.options = this.fields[index].options;
    this.rules.type = this.selected_type;


    //Setup the default values for everything
    if (this.selected_type == "boolean") {
      this.rules.value = false;
      this.rules.opr = 'equals';
    }
    else if (this.selected_type == "string") {
      this.rules.value = '';
      this.rules.opr = 'equals';
    }
    else if (this.selected_type == "category") {
      this.rules.value = [];
      this.rules.opr = 'contains-any';
    } else if (this.selected_type == "number") {
      this.rules.value = 0;
      this.rules.opr = 'equals';
    } else if (this.selected_type == "date") {
      this.rules.value = '2023-02-10';
      this.rules.opr = 'equals';
    }

    //this.globalService.GetArrayIndex(this.fields,this.rules.field);
  }

  async Remove() {
    this.removeRule.emit();
  }

}
